import style from './Proj.module.css';
import movie from '../images/movie.png';
import crawl from '../images/crawl.svg';
import quiz from '../images/quiz.svg';
import noimage from '../images/noimage.png';
import { useEffect, useRef } from 'react';

export default function Proj({ProjC}) {
    var index = 0;
    const cRef = useRef(null);
    const theta = 360/5;
    const radius = Math.round((500/ 2) / (Math.tan( Math.PI / 7 )) );
    const rotate = () => {
        if (cRef.current) {
            const angle = theta * index * -1;
            cRef.current.style.transform = `translateZ(${-radius}px) rotateY(${angle}deg)`;
        }
    }
    const next = () => {
        index++;
        rotate();
    }
    const prev = () => {
        index--;
        rotate()
    }

    const sectionRef = useRef(null)
    const options = {
        root: null,
        threshold: 0.05,
        rootMargin: "0px"
    }
    const callbackFunction = (entries) => {
        const[entry] = entries
        if (entry.isIntersecting) {
          document.getElementsByClassName(style.border)[0].classList.add(style.slidein)
        } 
      }

    useEffect (() => {
        const resize = () => {
            if (window.innerWidth <= 767) {
                cRef.current.style.transform = "none";
            } else {
                const angle = theta * index * -1;
                cRef.current.style.transform = `translateZ(${-radius}px) rotateY(${angle}deg)`;
            }
        }

        window.addEventListener("resize", resize)

        const section = sectionRef.current
        if (!section) return; 
        const theObserver = new IntersectionObserver(callbackFunction, options)
        theObserver.observe(section);
        return () => {
            theObserver.unobserve(section);
        }
    },[]);


    return (
        <>
            <div ref={ProjC} className={`${style.box} ${style.border}`} >
                <div className={`decor`}>
                    <hr></hr>
                    <h1>PROJECTS</h1>
                    <hr></hr>
                </div>
                <div ref={sectionRef} className={`banner_col ${style.projbox} `}>
                    <div ref={cRef} className={style.projs}>
                        <div className={`${style.carousel_cell} card`}>
                            <div className={`${style.accentBar} card-accent-bar accent-purple`}></div>
                            <div className={style.images}><img src={quiz}></img></div>
                            <div className={style.descrip}>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '2%'}}>
                                    <div>
                                        <h2 className='card-title-purple'>Quiz Game</h2>
                                        <h3>04/2021</h3>
                                        <div className={style.techStack}>
                                            <span className={style.techText}>Processing</span>
                                            <span className={style.techText}>Python</span>
                                        </div>
                                    </div>
                                    <a href='https://github.com/Kish170/Processing---Quiz-Game' target='_blank'><div className={`repos`}></div></a>
                                </div>
                                <p>This project is a quiz game focused on Computer Science topics 
                                    using Processing. I have incorporated animations, sound effects
                                    and a scoreboard so users could see their progress over time. 
                                    I used third-party libraries  to perform certain functionalities 
                                    such as creating a timer and adding sound effects.
                                </p>
                            </div>
                        </div>
                        <div className={`${style.carousel_cell} card`}>
                            <div className={`${style.accentBar} card-accent-bar accent-pink`}></div>
                            <div className={style.images}><img src={movie}></img></div>
                            <div className={style.descrip}>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '2%'}}>
                                    <div>
                                        <h2 className='card-title-pink'>MOVIE WEBSITE</h2>
                                        <h3>02/2023</h3>
                                        <div className={style.techStack}>
                                            <span className={style.techText}>Vue.js</span>
                                            <span className={style.techText}>JavaScript</span>
                                            <span className={style.techText}>Firebase</span>
                                            <span className={style.techText}>Axios</span>
                                            <span className={style.techText}>Pinia</span>
                                        </div>
                                    </div>
                                    <a href='https://github.com/Kish170/moviesite' target='_blank'><div className={`repos`}></div></a>
                                </div>
                                <p>This project is a movie streaming website that allows users to browse through 
                                    movies based on their search queries or through specific genres. Optimized Firebase 
                                    to store data, deploy the website and secure authentication. Utilized Axios to make 
                                    it easy to interact and retrieve data from the TMDb API
                                </p>
                            </div>

                        </div>
                        <div className={`${style.carousel_cell} card`}>
                            <div className={`${style.accentBar} card-accent-bar accent-blue`}></div>
                            <div className={style.images}><img src={crawl}></img></div>
                            <div className={style.descrip}>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '2%'}}>
                                    <div>
                                        <h2 className='card-title-blue'>Web Crawler</h2>
                                        <h3>12/2023</h3>
                                        <div className={style.techStack}>
                                            <span className={style.techText}>Java</span>
                                            <span className={style.techText}>Python</span>
                                            <span className={style.techText}>PageRank</span>
                                        </div>
                                    </div>
                                    <a href='https://github.com/Kish170/Spider-Search-Engine' target='_blank'><div className={`repos`}></div></a>
                                </div>
                                <p>This project is a Java-based web crawler and search engine 
                                    (with a Python version without a GUI). Starting from a seed URL, 
                                    the crawler gathers web page data, which the search engine analyzes 
                                    using PageRank algorithms to provide relevant search results for user queries.
                                </p>
                            </div>
                        </div>
                        <div className={`${style.carousel_cell} card`}>
                            <div className={`${style.accentBar} card-accent-bar accent-orange`}></div>
                            <div className={style.images}><img src={noimage}></img></div>
                            <div className={style.descrip}>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '2%'}}>
                                    <div>
                                        <h2 className='card-title-orange'>CUinSPACE Simulated Flight</h2>
                                        <h3>11/2024</h3>
                                        <div className={style.techStack}>
                                            <span className={style.techText}>C</span>
                                            <span className={style.techText}>Multithreading</span>
                                            <span className={style.techText}>POSIX</span>
                                        </div>
                                    </div>
                                    <a href='https://github.com/Kish170/COMP_2401-Project-2' target='_blank'><div className={`repos`}></div></a>
                                </div>
                                <p>This project simulates a system where an implementation of a manager oversees the event and resource handling within a rocket system. It uses dynamic memory management and linked lists to ensure efficient memory usage and data handling. The implementation of multithreading improves the performance, management, and runtime of the program.
                                </p>
                            </div>
                        </div>
                        <div className={`${style.carousel_cell} card`}>
                            <div className={`${style.accentBar} card-accent-bar accent-green`}></div>
                            <div className={style.images}><img src={noimage}></img></div>
                            <div className={style.descrip}>
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '2%'}}>
                                    <div>
                                        <h2 className='card-title-green'>Ultimate Note Taker</h2>
                                        <h3>12/2024</h3>
                                        <div className={style.techStack}>
                                            <span className={style.techText}>Next.js</span>
                                            <span className={style.techText}>TypeScript</span>
                                            <span className={style.techText}>GPT-4</span>
                                            <span className={style.techText}>Screenpipe</span>
                                        </div>
                                    </div>
                                    <a href='https://github.com/Kish170/summarizer_pipe' target='_blank'><div className={`repos`}></div></a>
                                </div>
                                <p>An AI-powered note-taking application that automatically generates notes from screen capture
                                    and audio data. Built with Next.js and GPT-4o, it features tag-based organization, bulk
                                    summarization, and local-first storage for privacy. Developed during a Screenpipe hackathon
                                    to solve the challenge of traditional note-taking during lectures and videos.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <a onClick={prev} id={style.prev} className='pages'>PREV</a>
                <a onClick={next} id={style.next} className='pages'>NEXT</a>
            </div>
        </>
    );
}